<template>
  <div>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          Delete Account Request
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="12" md="6">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name *"
                prepend-inner-icon="mdi-account"
                :error-messages="errors.name"
                placeholder="Enter your full name"
              ></v-text-field>
            </v-col>
            <v-col sm="12" md="6">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone Number *"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
                placeholder="Enter your registered phone number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="submit"
            :loading="isLoading"
          >
            Submit Request
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- Success Dialog -->
      <v-dialog v-model="showSuccessDialog" max-width="400" persistent>
        <v-card rounded="xl">
          <v-card-text class="text-center pt-6">
            <v-icon size="80" color="success">mdi-check-circle</v-icon>
            <h2 class="mt-4">Request Submitted</h2>
            <p class="mt-2">Your account deletion request has been submitted successfully. We will process it shortly.</p>
          </v-card-text>
          <v-card-actions class="justify-center pb-6">
            <v-btn color="primary" @click="resetForm">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DeleteAccountRequestCreate",
  data() {
    return {
      isLoading: false,
      showSuccessDialog: false,
      form: {
        name: "",
        phone: "",
      },
      errors: {},
    };
  },
  methods: {
    async submit() {
      this.errors = {};

      // Basic validation
      if (!this.form.name) {
        this.errors.name = ["Name is required"];
        return;
      }
      if (!this.form.phone) {
        this.errors.phone = ["Phone number is required"];
        return;
      }

      this.isLoading = true;
      try {
        const response = await axios.post("/account_delete_requests", this.form);
        if (response.data) {
          this.showSuccessDialog = true;
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          this.errors = error.response.data.errors;
        } else if (error.response && error.response.data && error.response.data.message) {
          this.errors = { general: [error.response.data.message] };
        } else {
          this.errors = { general: ["Something went wrong. Please try again."] };
        }
      } finally {
        this.isLoading = false;
      }
    },
    resetForm() {
      this.form = {
        name: "",
        phone: "",
      };
      this.showSuccessDialog = false;
    },
  },
};
</script>
